// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Oa2O","container":"styles_container__2NyCA","title":"styles_title__2FItB","wrapper":"styles_wrapper__9i_X9","answer":"styles_answer__1mbY_"};